import { store } from "../Redux/Store";
import { clearUser } from "../Redux/User/Action";
import { setAlertData } from "../Redux/Screen/Action";
import { safeNavigate } from "./Common";
import { disconnectChatHub } from "../Service/signalRService";

// Shared by Service/index.tsx's own 401-handling and NotificationContext.tsx's SessionEvicted
// listener, so both run the identical clear-and-redirect sequence instead of two independent
// (and potentially drifting) copies of it.
export const runForcedLogout = async (message: string = "Session expired. Please log in again.") => {
  await disconnectChatHub().catch(() => {});
  store.dispatch(
    setAlertData({ alertMessage: message, alertVariant: "error", openAlert: true }) as any
  );
  localStorage.clear();
  store.dispatch(clearUser() as any);
  safeNavigate("/login");
};
